import { memo } from 'react';
import { useAuth } from '@/hooks/useAuth';
import PublicNav from './PublicNav';
import PrivateNav from './PrivateNav';

interface NavigationProps {
  onConnectWallet?: () => void;
}

const Navigation = memo(function Navigation({
  onConnectWallet: _onConnectWallet,
}: NavigationProps) {
  const { user, isAuthenticated } = useAuth();

  // Show PrivateNav for authenticated users, PublicNav for guests
  if (isAuthenticated && user) {
    return <PrivateNav user={user} />;
  }

  return <PublicNav />;
});

export default Navigation;
